module.exports = __webpack_public_path__ + "img/lab-5.472ab3d6.png";